import { post } from '@alltrails/core/utils/post';
import type ProResponse from '../types/ProResponse';
import type { SubscriptionUpgrade } from '../types/Subscription';

// https://alpha.mostpaths.com/api/docs#tag/Need-Automation/operation/CreateSubscriptionUpgrade
export default async function createSubscriptionUpgrade(subscription: SubscriptionUpgrade) {
  return post<ProResponse>('/api/alltrails/purchases/subscription_upgrades', subscription);
}
